module.exports = __webpack_public_path__ + "img/tanker-grey.7adbee21.svg";